import { ApplicationRef, ComponentRef, createComponent } from '@angular/core';
import { OrderDiscountBannerComponent } from '@components/order-discount-banner/order-discount-banner.component';

export const createDiscountBannerComponent = (
  appRef: ApplicationRef
): {
  ref: ComponentRef<OrderDiscountBannerComponent>;
  element: HTMLElement;
} => {
  const ref = createComponent(OrderDiscountBannerComponent, {
    environmentInjector: appRef.injector
  });

  const element = ref.location.nativeElement;

  appRef.attachView(ref.hostView);

  return { ref, element };
};
